/*
 *
 * Ctydents reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_COMMUNICATION,
  LOAD_COMMUNICATION_SUCCESS,
  LOAD_COMMUNICATION_ERROR,
  UPDATE_COMMUNICATION,
  UPDATE_COMMUNICATION_SUCCESS,
  UPDATE_COMMUNICATION_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: true,
  error: false,
  itemDetail: false,
  detailID: false,
  // update
  updateLoading: false,
  updateError: false,
};

/* eslint-disable default-case, no-param-reassign */
const communicationDetailMobileReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      case LOAD_COMMUNICATION:
        draft.loading = true;
        draft.firstRender = action.firstRender;
        draft.detailID = action.detailID;
        break;

      case LOAD_COMMUNICATION_SUCCESS:
        draft.loading = false;
        draft.itemDetail = action.itemDetail;
        break;

      case LOAD_COMMUNICATION_ERROR:
        draft.error = action.error;
        draft.firstRender = false;
        draft.loading = false;
        draft.itemDetail = false;
        break;
      
      // Update for Single Element
      case UPDATE_COMMUNICATION:
        draft.updateLoading = true;
        draft.updateError = false;
        draft.itemDetail = action.itemDetail;
        break;

      case UPDATE_COMMUNICATION_SUCCESS:
        draft.updateLoading = false;
        draft.updateError = false;
        draft.itemDetail = {...state.itemDetail, ...action.itemDetail};
        break;

      case UPDATE_COMMUNICATION_ERROR:
        draft.updateError = action.updateError;
        draft.updateLoading = false;
        break;
    }
  });

export default communicationDetailMobileReducer;
